import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AppCN from "./AppCN";
import ErrorPage from "./error-page";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LaserLandingpage from "./LaserLandingpage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
  },
  {
    path: "laser",
    element: <LaserLandingpage />,
  },
  {
    path: "tw",
    element: <AppCN />,
  },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
